import styled from 'styled-components';
import ComponentAddon from "../ComponentAddon/ComponentAddon";
import { sizes } from "../../enums/sizeEnum";

var getButtonAddonSize = function getButtonAddonSize(_ref) {
  var size = _ref.size;

  if (sizes.small === size) {
    return "\n      width: 20px;\n      height: 20px;\n    ";
  }

  return "\n    width: 24px;\n    height: 24px;\n  ";
};

var ButtonAddon = styled(ComponentAddon).attrs({
  marginSize: 1
}).withConfig({
  displayName: "ButtonAddon",
  componentId: "sc-4r99k5-0"
})(["", ""], getButtonAddonSize);
ButtonAddon.defaultProps = {
  size: 'normal'
};
export default ButtonAddon;